import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
export default function PluginsScreen() {
  return <View style={{ padding: 32, gap: 12 }}><Text size="xxxl" weight="bold">Plugins</Text>
    <Text>Plugins are available in Gab AI for Mac.</Text></View>;
}
